<div [formGroup]="iiForm">

    <app-ativacao-section-card
        [control]="$any(isAtivoControl)"
        titulo="Importação"
        descricaoAtivo="Imposto de Importação ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="Imposto de Importação inativo. Nenhum valor de II será calculado nesta natureza de operação."
        emptyStateTitulo="Imposto de Importação desativado"
        emptyStateDescricao="Ative o Imposto de Importação acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-ii-tributo-regra-section
        [form]="iiForm"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasIi.length === 0"
        (personalizar)="abrirEditorFormulas()">
    </app-ii-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-ii-tributo-observacoes-section
        [control]="$any(iiForm.get('observacao'))"
        [variaveis]="variaveisUnicas"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-ii-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-ii-tributo-observacoes-fisco-section
        [control]="$any(iiForm.get('observacaoFisco'))"
        [variaveis]="variaveisUnicas"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-ii-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-ii-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [variaveis]="variaveisUnicas"
        [formulasIi]="formulasIi"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-ii-tributo-excecoes-section>

    }

</div>
